// export const domain = 'https://api.tis.coke.com'
export const domain = 'https://apigw.ko.com/api/tis/'
export const stage = 'prod'
export const featureFlags = {
  authorization: true
}